/* eslint-disable import/prefer-default-export */
/**
 * Maps platform language codes to QuickSight locale codes
 * @param language - Platform language code ('en', 'es', 'en-US', 'es-ES', etc.)
 * @returns QuickSight locale code ('en-US', 'es-ES', etc.)
 */
const getQuickSightLocale = (language: string | undefined | null): string => {
  // If no language provided, default to English
  if (!language) {
    return 'en-US';
  }

  // If already in correct format (e.g., 'es-ES', 'en-US'), return as-is
  if (language.includes('-')) {
    return language;
  }

  // Map short codes to full locale codes
  const localeMap: Record<string, string> = {
    en: 'en-US',
    es: 'es-ES',
    // Add more languages as needed:
    // pt: 'pt-BR',
    // de: 'de-DE',
    // fr: 'fr-FR',
  };

  return localeMap[language.toLowerCase()] || 'en-US';
};

export { getQuickSightLocale };
